export class ModalVideo {
  private static instance: ModalVideo;
  private modal: HTMLElement | null;
  private content: HTMLElement | null;
  private closeButton: HTMLElement | null;

  private constructor() {
    this.modal = document.querySelector('#videoModal');
    this.content = this.modal?.querySelector('.modal-video__content') || null;
    this.closeButton = this.modal?.querySelector('.modal-video__close') || null;
    this.initEvents();
  }

  public static getInstance(): ModalVideo {
    if (!ModalVideo.instance) {
      ModalVideo.instance = new ModalVideo();
    }
    return ModalVideo.instance;
  }

  private initEvents(): void {
    if (!this.modal) return;

    const overlay = this.modal.querySelector('.modal-video__overlay');
    overlay?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });

    this.closeButton?.addEventListener('click', () => this.close());
  }

  private getEmbedUrl(url: string): string {
    const videoId = url.split('v=')[1]?.split('&')[0];
    // Ajout des paramètres d'optimisation
    return videoId
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`
      : url;
  }

  public openYoutube(youtubeUrl: string): void {
    if (!this.modal || !this.content) return;

    const embedUrl = this.getEmbedUrl(youtubeUrl);

    this.modal.classList.add('is-loading');
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;

    iframe.addEventListener('load', () => {
      this.modal!.classList.remove('is-loading');
    });

    this.content.innerHTML = '';
    const iframeContainer = document.createElement('div');
    iframeContainer.className = 'modal-video__iframe';
    iframeContainer.appendChild(iframe);
    this.content.appendChild(iframeContainer);
  }

  private close(): void {
    if (!this.modal || !this.content) return;

    this.content.innerHTML = '';
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

export const modalVideo = ModalVideo.getInstance();
